import { render, staticRenderFns } from "./chinh-sach-bao-hanh.vue?vue&type=template&id=f2d8d998&"
import script from "./chinh-sach-bao-hanh.vue?vue&type=script&lang=js&"
export * from "./chinh-sach-bao-hanh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports